/* global store */

export const initSwipeGestures = () => {
  const {
    canAccessIframe,
    overlay,
    rootElement,
    sessionId,
    skins,
    wallpaper,
  } = store.getState();
  if ('initCustomEvent' in document.createEvent('CustomEvent')) {
    window.CustomEvent = (event, params) => {
      params = params || { bubbles: false, cancelable: true, detail: undefined };
      const evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
      return evt;
    };
    window.CustomEvent.prototype = window.Event.prototype;
  }

  let xDown = null;
  let yDown = null;
  let xDiff = null;
  let yDiff = null;
  let timeDown = null;
  let startEl = null;

  const handleTouchEnd = (e) => {
    e.stopPropagation();
    if (e.target.nodeName === 'IFRAME') return;
    if (!startEl) return;
    if (e.target.id !== startEl.id) return;
    const defaultThreshold = 20;
    const defaultTimeout = 500;
    const defaultClickthroughThreshold = 2;
    const swipeThreshold = startEl ? (parseInt(startEl.getAttribute('data-swipe-threshold'), 10) || defaultThreshold) : defaultThreshold;
    const swipeTimeout = startEl ? (parseInt(startEl.getAttribute('data-swipe-timeout'), 10) || defaultTimeout) : defaultTimeout;
    const timeDiff = Date.now() - timeDown;
    let eventType = '';

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      if (Math.abs(xDiff) > swipeThreshold && timeDiff < swipeTimeout) {
        if (xDiff > 0) {
          eventType = 'swiped-left';
        } else {
          eventType = 'swiped-right';
        }
      }
    } else if (Math.abs(yDiff) > swipeThreshold && timeDiff < swipeTimeout) {
      if (yDiff > 0) {
        eventType = 'swiped-up';
      } else {
        eventType = 'swiped-down';
      }
    } else if (timeDiff < defaultTimeout) {
      if ((Math.abs(xDiff) < defaultClickthroughThreshold) && (Math.abs(yDiff) < defaultClickthroughThreshold)) eventType = 'clicked';
    }

    if (eventType !== '') {
      if (eventType !== 'clicked') {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
      startEl.dispatchEvent(new CustomEvent(eventType, { bubbles: true, cancelable: true }));
    }
    // reset values
    xDown = null;
    yDown = null;
    timeDown = null;
  };

  const handleTouchStart = (e) => {
    if (e.target.nodeName === 'IFRAME') return;
    e.stopPropagation();
    if (e.target.getAttribute('data-swipe-ignore') === 'true') return;
    startEl = e.target;
    timeDown = Date.now();
    xDown = e.touches ? e.touches[0].clientX : e.clientX;
    yDown = e.touches ? e.touches[0].clientY : e.clientY;
    xDiff = 0;
    yDiff = 0;
  };

  const handleTouchMove = (e) => {
    if (!xDown || !yDown) return;
    const xUp = e.touches ? e.touches[0].clientX : e.clientX;
    const yUp = e.touches ? e.touches[0].clientY : e.clientY;
    xDiff = xDown - xUp;
    yDiff = yDown - yUp;
  };

  const eventList = {};
  if ('ontouchstart' in window) {
    eventList.touchstart = handleTouchStart;
    eventList.touchmove = handleTouchMove;
    eventList.touchend = handleTouchEnd;
  } else {
    eventList.mousedown = handleTouchStart;
    eventList.mousemove = handleTouchMove;
    eventList.mouseup = handleTouchEnd;
  }

  const initialiseListeners = (doc) => {
    Object.entries(eventList).forEach(([evt, funct]) => {
      doc.removeEventListener(evt, funct);
      doc.addEventListener(evt, funct);
    });
  };

  const removeListeners = (doc) => {
    Object.entries(eventList).forEach(([evt, funct]) => {
      doc.removeEventListener(evt, funct);
    });
  };

  const initialiseUnload = (frame) => {
    frame.contentWindow.addEventListener('unload', () => {
      try {
        const rootWindow = window.top;
        const registeredEvents = rootWindow['ivo-registered-event-sessions'] || [];
        rootWindow['ivo-registered-event-sessions'] = registeredEvents.filter(item => item !== sessionId);
        removeListeners(rootWindow.document);
      } catch (e) {
        console.log();
      }
    });
  };

  initialiseListeners(document);

  if (canAccessIframe && (overlay || skins || wallpaper)) {
    try {
      const rootWindow = wallpaper ? rootElement.ownerDocument.defaultView : window.top;
      if (rootWindow['ivo-api']) return;
      const registeredEvents = rootWindow['ivo-registered-event-sessions'] || [];
      registeredEvents.push(sessionId);
      rootWindow['ivo-registered-event-sessions'] = registeredEvents;
      initialiseUnload(frameElement);
      if (registeredEvents.length > 1) return;
      initialiseListeners(rootWindow.document);
    } catch (e) {
      console.log();
    }
  }
};



// WEBPACK FOOTER //
// ./app/javascript/renderer/utils/customEvents.js